'use client';

import { useTranslation } from '../lib/i18n';
import { useToast } from './Toast';

type Props = {
  value: string | number | null | undefined;
  className?: string;
};

export default function CopyableValue({ value, className }: Props) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const text = value === null || value === undefined ? '' : String(value);
  return (
    <span className={`inline-flex items-center gap-1.5 ${className ?? ''}`}>
      <span className="select-text">{text}</span>
      {text && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigator.clipboard?.writeText(text)
              .then(() => showToast(t('copied'), 'success'))
              .catch(() => {});
          }}
          className="text-wood hover:text-moss transition flex-shrink-0"
          title={t('copy')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a1.125 1.125 0 00-1.125-1.125H9.375A1.125 1.125 0 008.25 11.625v1.875" />
          </svg>
        </button>
      )}
    </span>
  );
}
